import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, Box, Skeleton } from '@mui/material';
import { getVendorAffinity } from '../../../../redux/thunks/affinityHubThunk';
import { actions } from '../../../../redux/reducers/affinityHubReducer';
import { CustomButtonGroup, SankeyChart } from '../../../shared';
import { CHANNELS } from './constants';

function VendorAffinity(props) {
    const { } = props;
    const dispatch = useDispatch();
    const { setVendorAffinityChannel } = actions;
    const { vendorAffinity } = useSelector(state => state.affinityHub);
    const { isLoading, chartSeries, categories, selectedChannel, vendors } = vendorAffinity;

    useEffect(() => {
        dispatch(getVendorAffinity());       
    },[]);

    return (
        <Box className="box-sizing-border-box">
            <Box className="pt-24px">
                <Box>
                    <Typography className="text-md-semi-bold gray-900">
                        Vendor Affinity
                    </Typography>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box className="padding-24px">
                                <Box className="flex-column gap-8 w-100">
                                    <Box>
                                        {isLoading ? <Skeleton variant="rounded" height={45} /> : <CustomButtonGroup
                                            data={categories}
                                            selected={selectedChannel}
                                            handleClick={(option) => dispatch(setVendorAffinityChannel({channel: option}))}
                                            customStyle={{
                                                width: '100%',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                            }}
                                            isButtonWidthEqual={true}
                                        />}
                                    </Box>
                                </Box>
                                {isLoading ? <Skeleton variant="rounded" height={500} /> : <SankeyChart 
                                    vendors={vendors}
                                    chartSeries={chartSeries}
                                />}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
}

export default VendorAffinity;
